
class FCM {
    onTokenRefresh() {
        this.messaging.getToken().then((token) => {
            console.log('Token refreshed', token);
            this.sendTokenToServer(token, true);
        }, (err) => {
            console.error('FCM.onTokenRefresh(): messaging.getToken()', err);
        });
    }

    onMessage(payload) {
        console.log('FCM.onMessage()', payload);
    }

    requestPermission() {
        this.messaging.requestPermission().then(() => {
            this.messaging.getToken().then((token) => {
                if (token) {
                    this.sendTokenToServer(token);
                }
            });
        }, (err) => {
            console.log('messaging.requestPermission()', err);
        });
    }

    sendTokenToServer(token, force) {
        if (this.isTokenSentToServer() && !force) {
            return;
        }

        this.setTokenSentToServer(false);

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        fetch('https://admin.childrenofearth.org/app-api/v1/register', {
            method: 'POST',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify({
                fcm_token: token,
                app_type: 'WEB',
                device_info: {}
            })
        }).then(resp => {
            if (resp.ok) {
                return resp.json();  // promise
            } else {
                throw new Error('response not ok');
            }
        }).then(json => {
            if (json.status === 'ok') {
                return json;
            } else {
                throw new Error(`bad status: ${json.status}`);
            }
        }).then(json => {
            this.setTokenSentToServer(true);
        }, err => {
            console.error('FCM.sendTokenToServer():', err);
        });
    }

    isTokenSentToServer() {
        return window.localStorage.getItem('FCM_TOKEN_SENT_TO_SERVER') === '1';
    }

    setTokenSentToServer(sent) {
        window.localStorage.setItem('FCM_TOKEN_SENT_TO_SERVER', sent ? '1' : '0');
    }

    main() {
        this.messaging = firebase.messaging();

        this.messaging.onTokenRefresh(() => this.onTokenRefresh());
        this.messaging.onMessage((payload) => this.onMessage(payload));

        this.messaging.getToken().then((token) => {
            if (token) {
                this.sendTokenToServer(token);
            } else {
                this.setTokenSentToServer(false);
                this.requestPermission();
            }
        }, (err) => {
            console.error('messaging.getToken()', err);
            this.setTokenSentToServer(false);
        });
    }
}

export default new FCM();



// WEBPACK FOOTER //
// ./site/js/fcm.js